import React from 'react'
import Header6 from '../../Globle/Header6'
import Smallnav from '../Mianhomesix/Smallnav'
import Banner from '../Mianhomesix/Banner'
import Client from '../Mianhomesix/Client'
import Deals from '../Mianhomesix/Deals'
import Advertise from '../Mianhomesix/Advertise'
import Catageory from '../Mianhomesix/Catageory'
import Work from '../Mianhomesix/Work'
import Subscribe from '../Mianhomesix/Subscribe'
import Blog from '../Mianhomesix/Blog'
import Footer6 from '../../Globle/Footer6'

const Main = () => {
    return (
        <>
            <Header6 />
            <Smallnav />
            <Banner />
            <Client />
            <Deals />
            <Advertise />
            <Catageory />
            <Work />
            <Subscribe />
            <Blog />
            <Footer6 />
        </>
    )
}

export default Main
